import { I18nComponente } from "@/types/gerais"

export const OAdicionarAtributoi18n: I18nComponente = {
  "pt-BR": {
    atributo: "atributo",
    adicionarAtributoSelecionado: "adicionar atributo selecionado",
    criarNovoAtributo: "criar novo atributo",
    precisarSelecionarUmAtributoPrimeiro: "precisar selecionar um atributo primeiro",
    issoNaoPode: "Isso não pode!",
    primeiroVocePrecisaEscolherUmAtributo: "primeiro, você precisa escolher um atributo",
    duplicado: "Duplicado!",
    esseAtributoJaFoiAdicionadoNaLista: "Esse atributo já foi adicionado na lista",
  },
  "es-CO": {
    atributo: "atributo",
    adicionarAtributoSelecionado: "adicionar atributo seleccionado",
    criarNovoAtributo: "añadir nuevo atributo",
    precisarSelecionarUmAtributoPrimeiro: "necesitar seleccionar un atributo primero",
    issoNaoPode: "¡Esto no puede!",
    primeiroVocePrecisaEscolherUmAtributo: "primero, você precisa escolher um atributo",
    duplicado: "Duplicado!",
    esseAtributoJaFoiAdicionadoNaLista: "Este atributo ya ha sido agregado a la lista",
  },
}
